import { queryCache } from '../../../utils/queryCache';
export const PREFERENCES_CHANGED_EVENT = 'mestti-preferences-changed';
export const PREFERENCES_REVISION_KEY = 'mestti-preferences-revision';

// No identity or preference payload crosses browser tabs. Each tab re-reads its
// own authenticated endpoint. Invalidate only responses that consume ordering.
export function invalidatePreferenceConsumers(): void {
    queryCache.invalidatePrefix('monitoramento:/api/v1/production/maquinas/dashboard');
    queryCache.invalidatePrefix('monitoramento:/api/v1/production/monitoramento/setorial');
}

export function subscribePreferencesChanged(listener: (sourceId: string | null) => void): () => void {
    const receive = (sourceId: string | null) => { invalidatePreferenceConsumers(); listener(sourceId); };
    const local = (event: Event) => {
        const sourceId = (event as CustomEvent<{ sourceId?: string }>).detail?.sourceId ?? null;
        receive(sourceId);
    };
    const storage = (event: StorageEvent) => {
        if (event.key === PREFERENCES_REVISION_KEY) receive(null);
    };
    window.addEventListener(PREFERENCES_CHANGED_EVENT, local);
    window.addEventListener('storage', storage);
    return () => {
        window.removeEventListener(PREFERENCES_CHANGED_EVENT, local);
        window.removeEventListener('storage', storage);
    };
}
